import React from 'react';
import { ButtonGrid, Container, WashButton } from './StartVacuumCleanerStyles';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';

const StartVacuumCleaner: React.FC = () => {
  const [searchParams] = useSearchParams();
  const station = searchParams.get("station") ?? "";

  const handleWashClick = async (aspId: string) => {
    const baseUrl = 'https://api.redezandona.com.br/api/v1/vacuumcleaner/publish';

    try {
      const response = await axios.post(baseUrl, {
        id: aspId,
        status: "on",
        time_on: 10,
        stationCode: station || ""
      });
      console.log(`Requisição bem-sucedida para ${aspId}:`, response.data);
    } catch (error) {
      console.error(`Erro ao enviar comando ${aspId}:`, error);
    }
  };

  return (
    <Container>
      <ButtonGrid>
        <WashButton onClick={() => handleWashClick('z7asp1')}>z7asp1</WashButton>
        <WashButton onClick={() => handleWashClick('z7asp2')}>z7asp2</WashButton>
        <WashButton onClick={() => handleWashClick('z7asp3')}>z7asp3</WashButton>
        <WashButton onClick={() => handleWashClick('asp1')}>asp1</WashButton>
      </ButtonGrid>
    </Container>
  );
};

export default StartVacuumCleaner;
